type Alternates = {
  canonical: string
  languages: { [key: string]: string }
}

export function getAlternateMetadataFromHeader(
  input: string,
  locale: string,
): Alternates {
  const links = input.split(", ")
  let canonical = ""
  const languages: { [key: string]: string } = {}

  links.forEach((link) => {
    const parts = link.split("; ")
    const url = parts[0].trim().slice(1, -1) // Remove the angle brackets
    let hreflang: string = ""

    parts.slice(1).forEach((part) => {
      const [key, value] = part.split("=")
      if (key === "hreflang") {
        hreflang = value.replace(/"/g, "") // Remove quotes
      }
    })

    if (hreflang === locale) {
      canonical = url
    }
    languages[hreflang] = url
  })

  return { canonical, languages }
}

export const getAlternateMetadataFromPathname = (
  pathname: string,
  locale: string,
  jobid?: string,
): Alternates => {
  const languages: { [key: string]: string } = {}
  pathname = pathname
    .replace("[locale]", locale)
    .replace("[jobid]", jobid || "")
  /* EGDE-669: English was discarded from the site, so an "/en-us/…" or "/en/…"
     input no longer canonicalises to a live "/en/…" URL — it collapses to the
     prefix-less Hebrew path like the Hebrew spellings already did. */
  const canonical = pathname
    .replace(/^\/(en-us|en)(\/|$)/, "/")
    .replace(/^\/(he-il)\//, "/")
    .replace(/^\/(he)(\/|$)/, "/")

  const noLocalePathname = pathname.replace(/^\/(en-us|he-il|en|he)(\/|$)/, "/")

  languages["he"] = noLocalePathname
  languages["x-default"] = noLocalePathname

  // Non-default locales are served under a path prefix (next-intl as-needed).
  languages["ar"] = `/ar${noLocalePathname}`
  languages["ru"] = `/ru${noLocalePathname}`
  return { canonical, languages }
}
